<template>
  <transition name="fade" appear>
    <div class="bg-white-high-emphasis inset-0 flex items-center justify-center">
      <div
      class="w-96 h-96"
      style="min-height: 500px; min-width: 50vw;"
      ref="lottieContainer"
    >
    </div>
    </div>
  </transition>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
import { hexToRgba } from '@/utils/colors'
import { loadingJSON } from './KLoading'
import lottie from "lottie-web/build/player/lottie_light";
import { ref, onMounted } from 'vue';
export default defineComponent({
  name: 'KLoading',
  setup () {
  const lottieContainer = ref(null)
  onMounted(() => {
    const root = document.documentElement
     const color = root.style.getPropertyValue('--color-primary')
     const animationJSON = loadingJSON(hexToRgba(color, 1, 'arithmetic'))
    lottie.loadAnimation({
      container: lottieContainer.value, 
      animationData: animationJSON,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      name: "MyAnimation",
  })
})
    return { lottieContainer }
  },
})
</script>